const viewBusinessDetailsTypes = {
  VIEW_BUSINESS_DETAILS_START: "VIEW_BUSINESS_DETAILS_START",
  VIEW_BUSINESS_DETAILS_FAILURE: "VIEW_BUSINESS_DETAILS_FAILURE",
  VIEW_BUSINESS_DETAILS_SUCCESS: "VIEW_BUSINESS_DETAILS_SUCCESS",
  VIEW_BUSINESS_DETAILS_CHANGED: "VIEW_BUSINESS_DETAILS_CHANGED",
  VIEW_BUSINESS_DETAILS_RESET: "VIEW_BUSINESS_DETAILS_RESET",
};

export default viewBusinessDetailsTypes;
